import { hot } from "react-hot-loader";

import React from "react";
import { ApolloProvider, Query } from "react-apollo";
import { bool, string } from "prop-types";

import isNotLoggedIn from "src/shared/utilities/graphql/isNotLoggedIn";

import apolloClient from "../../connection/apolloClient";
import AGENT_QUERY from "../../graphql/queries/agent";
import VIEWER_QUERY from "../../graphql/queries/viewer";
import ShareItem from "../ShareItem";

const App = ({ isAgent, itemAddress, itemArea, itemId, itemType, siteKey }) => {
  const ShareItemWithUserData = (
    data = {
      email: "",
      industry_professional: { industry_professional_share_tokens: [] }
    }
  ) => (
    <ShareItem
      exclusiveMarketingTokens={
        isAgent
          ? data.industry_professional.industry_professional_share_tokens
          : []
      }
      isAgent={isAgent}
      itemAddress={itemAddress}
      itemArea={itemArea}
      itemId={itemId}
      itemType={itemType}
      siteKey={siteKey}
      userEmail={data.email}
    />
  );

  const handleViewerQueryError = error => {
    if (isNotLoggedIn(error)) {
      return ShareItemWithUserData();
    }

    return <p>{`Error occurred: ${error.message}`}</p>;
  };

  return (
    <ApolloProvider client={apolloClient}>
      <Query query={isAgent ? AGENT_QUERY : VIEWER_QUERY}>
        {({ data, error, loading }) => {
          if (loading) return null;
          if (error) {
            return handleViewerQueryError(error);
          }
          if (data) {
            const { viewer } = data;

            return ShareItemWithUserData(viewer);
          }

          return null;
        }}
      </Query>
    </ApolloProvider>
  );
};

App.propTypes = {
  isAgent: bool,
  itemAddress: string.isRequired,
  itemArea: string.isRequired,
  itemId: string.isRequired,
  itemType: string.isRequired,
  siteKey: string.isRequired
};

App.defaultProps = {
  isAgent: false
};

export default hot(module)(App);
